import { App } from "vue";

import { addIcons, OhVueIcon } from "oh-vue-icons";
import * as AiIcons from "oh-vue-icons/icons/ai";
import * as CoIcons from "oh-vue-icons/icons/co";
import * as HiIcons from "oh-vue-icons/icons/hi";
import * as MdIcons from "oh-vue-icons/icons/md";
import * as FaIcons from "oh-vue-icons/icons/fa";
import * as RiIcons from "oh-vue-icons/icons/ri";
import * as PrIcons from "oh-vue-icons/icons/pr";
import * as IoIcons from "oh-vue-icons/icons/io";
import * as BiIcons from "oh-vue-icons/icons/bi";
import * as FcIcons from "oh-vue-icons/icons/fc";



const icons = Object.values({
  ...HiIcons,
  ...MdIcons,
  ...AiIcons,
  ...CoIcons,
  ...FaIcons,
  ...RiIcons,
  ...PrIcons,
  ...IoIcons,
  ...BiIcons,
  ...FcIcons
});
addIcons(...icons);
export default function setIcons(app: App): void {
  app.component("v-icon", OhVueIcon);
}